module.exports = __webpack_public_path__ + "media/coffee-preferences/adventurousness_low-c3c5ec1d.png";